import { FC } from 'react';

export const BlogHeader: FC = () => (
    <div className="mb-4 max-w-3xl">
        <h1 className="mb-3 text-3xl font-bold">Блог CartOn</h1>
        <p className="text-muted-foreground">
            Гіди, поради та новини для колекціонерів TCG-карток в Україні.
            Дізнавайтесь, як купувати без ризику, продавати швидше і краще
            орієнтуватись у світі Pokemon, One Piece та інших TCG.
        </p>
    </div>
);
